export default __webpack_public_path__ + "static/media/job_offer15_s.34edcd5e.jpg";